import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
	fetchCareerGuides,
	fetchCityGuides,
	fetchDegreeGuides,
} from '../../data-access/+state/guides.actions';
import {
	getStatePopularCareerGuides,
	getStatePopularCityGuides,
	getStatePopularDegreeGuides,
} from '../../data-access/+state/guides.selectors';
import { SnigelService } from '@uc/web/core';
import { SeoMetadataService } from '@uc/utilities';
import { RecommendedUnisCarouselComponent } from '@uc/web/shared/feature/feature-recommended-universities';
import { StickyLeadBarRendererComponent } from '@web/shared/feature/feature-sticky-lead-bar';
import { MainHeaderComponent } from '@web/shared/ui';
import { META_DATA } from '../../static/guides.properties';
import { GuidesHeaderNavigationComponent } from '../../components/guides-header-navigation/guides-header-navigation.component';
import { GuidesCarouselComponent } from '../../components/guides-carousel/guides-carousel.component';
import { GuidesCarouselFooterComponent } from '../../components/guides-carousel-footer/guides-carousel-footer.component';

@Component({
	selector: 'uc-guides',
	templateUrl: './guides.component.html',
	imports: [
		MainHeaderComponent,
		AsyncPipe,
		GuidesHeaderNavigationComponent,
		GuidesCarouselComponent,
		GuidesCarouselFooterComponent,
		StickyLeadBarRendererComponent,
		RecommendedUnisCarouselComponent,
	],
})
export class GuidesComponent implements OnInit, AfterViewInit {
	degreeGuides$!: Observable<any>;
	cityGuides$!: Observable<any>;
	careerGuides$!: Observable<any>;

	constructor(
		private _store: Store,
		private _seoSrv: SeoMetadataService,
		private _snigelSrv: SnigelService,
	) {}

	ngOnInit(): void {
		this._seoSrv.updateTitle(META_DATA.title);
		this._seoSrv.updateDescription(META_DATA.description);

		this._store.dispatch(fetchDegreeGuides());
		this._store.dispatch(fetchCityGuides());
		this._store.dispatch(fetchCareerGuides());

		this.cityGuides$ = this._store.select(getStatePopularCityGuides);
		this.degreeGuides$ = this._store.select(getStatePopularDegreeGuides);
		this.careerGuides$ = this._store.select(getStatePopularCareerGuides);
	}

	ngAfterViewInit(): void {
		this._snigelSrv.getAds([
			'incontent_1_dskt',
			'incontent_1_mob',
			'incontent_2_dskt',
			'incontent_2_mob',
		]);
	}
}
